import {BenefitOneData} from "@/data";
import React from "react";
import {Col, Container, Row} from "react-bootstrap";

const BenefitOne = () => {
    const {title, posts} = BenefitOneData;
    return (
        <section className="service_benefits_area  section_border section_padding">
            <Container>
                <Row>
                    <Col lg={12}>
                        <div className="hero-section-title mt-4">
                            <h2>Con quali prodotti?</h2>
                            <p className="text-black">La gamma dei prodotti a disposizione per i nostri servizi soddisfa
                                tutte le esigenze legate a una pulizia e a una igienizzazione profonda:</p>
                            <ul>
                                <li>
                                    <i className="fa fa-check-circle"></i> detergenti - concentrati e non
                                </li>
                                <li>
                                    <i className="fa fa-check-circle"></i> alcalini
                                </li>
                                <li>
                                    <i className="fa fa-check-circle"></i> acidi
                                </li>
                                <li>
                                    <i className="fa fa-check-circle"></i> fino ai prodotti per la profumazione e la sanificazione dell’aria.
                                </li>
                            </ul>
                            <p className="text-black">Prodotti adatti ad ogni tipo di superficie, per la pulizia professionale HACCP.</p>

                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col lg={12}>
                        <div className="hero-section-title mt-4">
                            <h2>Con quali macchinari?</h2>
                            <p className="text-black">La gamma di prodotti sopra elencata è naturalmente abbinata a una serie di macchinari specifici:</p>
                            <ul>
                                <li>
                                    <i className="fa fa-check-circle"></i>  Monospazzole tradizionali e orbitali, che consentono di affrontare interventi quali lavaggio, pulizia di fondo, deceratura, lucidatura, cristallizzazione e permettono di agire su qualsiasi tipo di pavimentazione
                                </li>
                                <li>
                                    <i className="fa fa-check-circle"></i>  Aspiratori per solidi e per liquidi
                                </li>
                                <li>
                                    <i className="fa fa-check-circle"></i>  Macchine ad iniziezione ed estrazione che consentono il lavaggio di ogni tipo di tessuto (sedie, divani, tende, tappeti…)
                                </li>
                                <li>
                                    <i className="fa fa-check-circle"></i>  Sanificatori, per rispondere all’emergenza Covid-19: ad ozono e con nebulizzazione al periossido d’idrogeno
                                </li>
                                <li>
                                    <i className="fa fa-check-circle"></i>  Lavasciuga, sia con uomo a terra che con uomo a bordo
                                </li>
                            </ul>

                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col lg={12}>
                        <div className="hero-section-title text-center">
                            <h1>Altri Servizi</h1>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col lg={12}>
                        <h2>Servizi Speciali:</h2>
                        <ul>
                            <li>
                                <i className="fa fa-check-circle"></i> profumazione spring air (profumazione ambienti
                                tramite vaporizzatori e nebulizzatori che rilasciano prodotti naturali)
                            </li>
                        </ul>
                        <h2 className="mt-4">Giardinaggio:</h2>
                        <ul>
                            <li>
                                <i className="fa fa-check-circle"></i> Servizi di manutenzione e cura di giardini e
                                verde pubblico, giardini privati.
                            </li>
                        </ul>
                        <h2 className="mt-4">Trasporto e consegna:</h2>
                        <ul>
                            <li>
                                <i className="fa fa-check-circle"></i> Trasloco, facchinaggio, montaggio e smontaggio di
                                mobili e arredi.
                            </li>
                            <li>
                                <i className="fa fa-check-circle"></i>Gestione di servizi di logistica per magazzini,
                                depositi, cantieri e
                                archivi.
                            </li>
                        </ul>
                    </Col>
                </Row>

            </Container>
        </section>
    );
};

export default BenefitOne;
